/**
 * date：2022-04-18
 * author：brian
 * purpose：公共接口
 */
import { shareParam, shareRoleType } from '@/api/modules/public.js';
const mixin = {
    methods: {
        shareParamFn(obj) {
            return shareParam(obj)
        },
        getRoleType(obj) {
            return shareRoleType(obj)
        }
    }
}

export default mixin
